var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightLight = function SvgArrowRightLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26.668 16 .471-.471.472.471-.472.471-.471-.471Zm-20 .667a.667.667 0 0 1 0-1.334v1.334Zm12-8.667.471-.471 8 8-.471.471-.471.471-8-8L18.668 8Zm8 8 .471.471-8 8-.471-.471-.471-.471 8-8 .471.471Zm0 0v.667h-20v-1.334h20V16Z",
    fill: "#fff"
  })));
};
export default SvgArrowRightLight;